/**
 * Markdown related redux state.
 */

import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "../store"

interface MarkdownState {
	// Values may be a string, null (cleared), or a FileReader result depending on caller
	current: Record<string, any>
	previous: Record<string, any>
}

const initialState: MarkdownState = {
	current: {},
	previous: {},
}

export const markdownSlice = createSlice({
	name: "markdown",
	initialState,
	reducers: {
		setMarkdown(state, { payload }: PayloadAction<{ id: string; markdown: string | ArrayBuffer | null | undefined }>) {
			state.current[payload.id] = payload.markdown
		},
		setPreviousMarkdown(state, { payload }: PayloadAction<{ id: string; markdown: string | ArrayBuffer | null | undefined }>) {
			state.previous[payload.id] = payload.markdown
		},
	},
})

export const { setMarkdown, setPreviousMarkdown } = markdownSlice.actions

export const markdownSelector = (id: string) => (state: RootState) => state.markdown.current[id]
export const previousMarkdownSelector = (id: string) => (state: RootState) => state.markdown.previous[id]
